<template>
    <div :class="`search-item consultant ${isGrid ? 'grid' : 'bar'}`">
        <div v-if="isGrid" cols="12" class="search-item-grid-details">
            <div class="field data-company_name">
                <div>
                    <label
                        for="consultant-company_name"
                        v-text="`${t('consultants::form.label.company_name')}:`"
                    ></label>
                    <span
                        v-text="searchItem.data.company_name ? searchItem.data.company_name : t('search::label.na')"
                    ></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div class="field data-dms_id">
                <div>
                    <label for="consultant-dms_id" v-text="`${t('consultants::label.dms_id')}:`"></label>
                    <span v-text="searchItem.data.dms_id ? searchItem.data.dms_id : t('search::label.na')"></span>
                </div>
            </div>
            <span class="divider">/</span>
            <div class="field data-gmc_number">
                <div>
                    <label for="consultant-gmc_number" v-text="`${t('consultants::label.gmc_id')}:`"></label>
                    <span
                        v-text="searchItem.data.gmc_number ? searchItem.data.gmc_number : t('search::label.na')"
                    ></span>
                </div>
            </div>
        </div>
        <v-row v-else no-gutters>
            <v-col cols="12" class="p-0 pb-2">
                <div class="grid-status">
                    <span v-text="t(`search::types.${searchItem.type}`)"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field name">
                <span>
                    {{ searchItem.name ? searchItem.name : t('search::label.na') }}
                </span>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-company_name">
                <div>
                    <label
                        for="consultant-company_name"
                        v-text="`${t('consultants::form.label.company_name')}:`"
                    ></label>
                    <span
                        v-text="searchItem.data.company_name ? searchItem.data.company_name : t('search::label.na')"
                    ></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-dms_id">
                <div>
                    <label for="consultant-dms_id" v-text="`${t('consultants::label.dms_id')}:`"></label>
                    <span v-text="searchItem.data.dms_id ? searchItem.data.dms_id : t('search::label.na')"></span>
                </div>
            </v-col>
            <v-col cols="12" class="p-0 pb-1 field data-gmc_number">
                <div>
                    <label for="consultant-gmc_number" v-text="`${t('consultants::label.gmc_id')}:`"></label>
                    <span
                        v-text="searchItem.data.gmc_number ? searchItem.data.gmc_number : t('search::label.na')"
                    ></span>
                </div>
            </v-col>
        </v-row>
        <div v-if="can('consultants.get') && !isGrid" class="search-item-actions">
            <v-tooltip top transition="v-fab-transition" z-index="999999">
                <template #activator="{ on, attrs }">
                    <div
                        class="search-item-actions-button"
                        v-bind="attrs"
                        v-on="on"
                        @click="$root.goTo(editSearchItemUrl(item))"
                    >
                        <v-icon size="18">mdi-arrow-right</v-icon>
                    </div>
                </template>
                <span>{{ t('search::label.actions.go_to_record') }}</span>
            </v-tooltip>
        </div>
    </div>
</template>

<script>
import SearchMixin from '../..//mixins/SearchMixin';
export default {
    mixins: [SearchMixin],
    methods: {
        editSearchItemUrl(item) {
            return route(`${item.type.replace('_', '-')}s.get`, { id: item.id });
        },
    },
};
</script>

<style></style>
